<template>
  <div>
    <b-container>
      <div class="row pt-3">
        <div class="col" >
          <img src="./../../../assets/web/img/logo-pgj.png" alt="large" />
        </div>
        <div class="col d-none d-sm-block">
          <a href="https://www.chinaeinv.net" class="float-right pt-3">
            <i class="fa fa-home" aria-hidden="true"></i>&nbsp;
            <span>返回首页</span>
          </a>
        </div>
      </div>
    </b-container>
    <b-container
      fluid
      class="my-3"
      style="border-bottom: 1px solid #eee; border-top: 1px solid #eee;"
    >
      <div class="container">
        <div class="row vertical-offset-80 pt-4">
          <div class="col-lg-7 d-none d-lg-block">
            <img src="./../../../assets/web/img/login-left.png" />
          </div>
          <div class="col-lg-4">
            <div class="card pt-3">
              <div class="card-body shadow-sm">
                <div class="mb-3 border-bottom border-muted">
                  <h4>登录</h4>
                </div>
                <form id="credential" class="form-horizontal " method="post">
                  <div id="alert"></div>
                  <validation-observer ref="loginForm">
                    <div class="mb-3">
                      <validation-provider
                        :rules="validators.rules.username"
                        :customMessages="validators.msgs.username"
                        name="用户名"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          id="username"
                          label="用户名"
                          label-for="username"
                          :invalid-feedback="validationContext.errors[0]"
                        >
                          <b-form-input
                            id="username"
                            type="text"
                            required
                            :state="validateState(validationContext)"
                            v-model="loginParam.username"
                            placeholder="用户名或手机号"
                          ></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                    <div class="mb-3">
                      <validation-provider
                        :rules="validators.rules.password"
                        :customMessages="validators.msgs.password"
                        name="密码"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          id="password"
                          label="密码"
                          label-for="password"
                          :invalid-feedback="validationContext.errors[0]"
                        >
                          <b-form-input
                            id="password"
                            type="password"
                            required
                            maxlength="32"
                            v-model="loginParam.password"
                            :state="validateState(validationContext)"
                            placeholder="密码"
                          ></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </div>
                    <div class="mb-3">
                      <button
                        type="button"
                        class="btn btn-primary btn-block mt-4"
                        @click="openVerify"
                      >登 录</button>
                    </div>
                  </validation-observer>
                </form>
                <div class="row ">
                  <div class="col">
                    <router-link to="register">用户注册</router-link>
                  </div>
                  <div class="col">
                    <router-link to="passwordreset" class="float-right">忘记密码?</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>

    <b-modal
      id="verifyModal"
      ref="modal-verify"
      v-model="verifyVisible"
      centered
      size="md"
      hide-footer
      style="max-width:200px"
      title="请完成以下拼图验证"
    >
      <!-- :imgSize="{ width: '470px', height: '250px' }" -->
      <Verify @success="handleLogin" :mode="'fixed'" :captchaType="'blockPuzzle'" ref="verify" />
    </b-modal>
  </div>
</template>

<script>
import util from "@/libs/util.js";
import Verify from "@/components/captcha/Verify.vue";
import { AccountLogin } from "./../../../api/sys.login.js";
export default {
  // 模板名
  name: "AdminLoginForm",
  components: {
    Verify
  },

  data() {
    return {
      // 登陆表单
      loginParam: {
        username: "",
        password: "",
        verifyVisible: false
      },
      verifyVisible: false,
      // 错误提示
      validators: {
        rules: {
          username: {
            required: true,
            min: 6,
            max: 20
          },
          password: {
            required: true,
            min: 6,
            max: 20
          }
        },
        msgs: {
          username: {
            required: "请输入用户名",
            min: "长度在6到20个字符",
            max: "长度在6到20个字符"
          },
          password: {
            required: "请输入密码",
            min: "长度在6到20个字符",
            max: "长度在6到20个字符"
          }
        }
      }
    };
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    openVerify() {
      this.$refs.loginForm.validate().then(valid => {
        if (valid) {
          //let param = { captchaVerification: "11" };
          //this.handleLogin(param);
          this.verifyVisible = true;
        } else {
          // 登录表单校验失败
          this.$message({
            message: "请填写正确的用户名和密码",
            type: "danger"
          });
        }
      });
    },
    // 提交登陆
    handleLogin(params) {
      this.verifyVisible = false;
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.loginParam.captchaVerification = params.captchaVerification;
      AccountLogin(this.loginParam)
        .then(res => {
          if(res && res.id){
            // res.uuid = "33333333333333333333";
            // res.token = "88999999999999999999";
            //util.cookies.set("token", "888888");
            util.cookies.set("uuid", res.id);

            // 设置 vuex 用户信息
            this.$store.dispatch("admin/user/set", res, {
              root: true
            });
            this.$store.dispatch("admin/user/load");

            let roles=res.roles;
            console.log(roles.indexOf("tcs_jgdw")>-1);
            console.log(roles.indexOf("tcs_ent")>-1);
            if(roles.indexOf("tcs_jgdw")>-1){
              //信链监管单位
              this.$router.replace("/tcs/ent");
            }else if(roles.indexOf("tcs_ent")>-1){
              //信链被监管企业
              this.$router.replace("/tcs/upload-task");
            }else{
            this.$router.replace(this.$route.query.redirect || "/");
            }
         
          }
        })
        .catch(err => {
          console.log("err", err);
        });
      // let res = {
      //   uuid: "33333333333333333333",
      //   token: "88999999999999999999",
      //   name: "系统"
      // };
      // util.cookies.set("uuid", res.uuid);
      // util.cookies.set("token", res.token);
      // // 设置 vuex 用户信息
      // this.$store.dispatch("admin/user/set", res, {
      //   root: true
      // });
      // this.$router.replace(this.$route.query.redirect || "/index");
    },
    // 自动关闭alert
    countDownChanged(dismissCountDown) {
      this.loginFormErrorAlert.dismissCountDown = dismissCountDown;
    }
  }
};
</script>

<style >
.font-14 {
  font-size: 14px;
}
#verifyModal .modal-dialog {
  max-width: 340px !important;
  margin: 1.75rem auto;
}
</style>